<div class="row">
  <div class="col-12 py-5 page-title">
    <h4>Devices</h4>
    <a class="btn btn-primary text-white" routerLink="create">
      Add New
    </a>
    <a class="btn btn-primary text-white" (click)="openBulkEditModal(bulkEditContent)" *ngIf="selectedDevices.length">
      Bulk Edit
    </a>
  </div>
</div>

<ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
  <li [ngbNavItem]="1" class="nav-item">
    <a ngbNavLink class="nav-link">Active</a>
    <ng-template ngbNavContent>
    <div class="row tab-pane">
      <div *ngFor="let device of deviceList" class="col-12 col-md-6 col-lg-12 col-xl-6">
        <div class="grid device-card" [class.offline]="!device.online" [class.connected]="device.connection_status === 'connected'" [class.border-success]="device.selected">
          <div class="grid-body text-gray row">
            <div class="device-header">
              <div class="">
                <p class="display-6 device-title" routerLink="{{device.id}}">
                  <span class="device-title-text">{{device.name}}</span>
                  <img *ngIf="device.online && device.rssi_value" class="signal-icon" src="/assets/images/signal-{{device.rssi_value}}.png" />
                  <span *ngIf="!device.rssi_value || !device.online" class="badge device-status" [class.badge-success]="device.online" [class.badge-danger]="!device.online">&nbsp;</span>
                  <!--button type="button" class="btn btn-trasnparent action-btn btn-xs component-flat pr-0 expand-button"  routerLink="{{device.id}}">
                    <i class="mdi mdi-arrow-expand"></i>
                  </button-->
                  <!--span *ngIf="device?.cell_state?.toLowerCase()?.includes('pause')" class="badge cell-state">Paused</span-->
                </p>
                <input type="checkbox" class="form-check-input device-checkbox" [(ngModel)]="device.selected" (ngModelChange)="updateSelectedDevices()" />
              </div>
            </div>
          </div>

          <div class="grid-body text-gray row device-info">
            <div class="col-6 col-xl-3 col-lg-3 col-md-6 col-sm-3">
              <span class="info-label">MAC/Serial</span>
              {{device.code}}
            </div>
            <div class="col-6 col-xl-3 col-lg-3 col-md-6 col-sm-3">
              <span class="info-label">Org</span>
              {{device.org?.name}}
            </div>
            <div class="col-6 col-xl-3 col-lg-3 col-md-6 col-sm-3">
              <span class="info-label">Site</span>
              {{device.location?.company}}
            </div>
            <div class="col-6 col-xl-3 col-lg-3 col-md-6 col-sm-3">
              <!--
              <span class="info-label">Cell Plan</span>
              <span>{{device.cell_usage ? (device.cell_usage / 1000000) + 'Mb' : '?'}} / </span>
              <span *ngIf="device.cell_limit === -1">Unlimited</span>
              <span *ngIf="device.cell_limit !== -1">{{device.cell_limit ? (device.cell_limit / 1000000) + 'Mb' : '?'}}</span>
              -->
              <button type="button" class="btn btn-primary btn-xs connect-button" *ngIf="device.connection_status === 'disconnected'" (click)="activateDevice(device)">
                <i class="mdi mdi-lan-connect"></i> Connect
              </button>

              <button type="button" class="btn btn-success btn-xs connect-button" *ngIf="device.connection_status === 'connected'" (click)="deactivateDevice(device)">
                <i *ngIf="device.connections.length <= 2" class="mdi mdi-lan-connect"></i> Connected
              </button>

              <button type="button" class="btn btn-primary btn-xs connect-button" *ngIf="device.connection_status === 'connecting'" disabled="disabled">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span class="sr-only">Loading...</span>
              </button>
            </div>
          </div>

          <div class="grid-body text-gray row">
            <div *ngFor="let connection of device.connections.slice(0,3);">
            <div *ngIf="connection.ips.length" class="col-3 device-connection">
              <span class="device-type">{{connection.vendor.name}}</span>
              <div *ngIf="connection.ips.length > 1" class="dropdown">
                <button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{connection.ips.length+' IPs'}}
                </button>
                <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                  <li *ngFor="let ip of connection.ips" class="dropdown-item">{{ip.ip}}</li>
                </ul>
              </div>
              <span *ngIf="connection.ips.length <= 1">
                {{connection.ips.length !== 1 ? connection.ips.length+' IPs' : connection.ips[0]?.ip}}
              </span>
            </div>
            </div>
            <div *ngIf="device.connection_status === 'connected'" class="col-3 device-connection">
              <button type="button" class="btn btn-primary btn-xs" routerLink="{{device.id}}">All Connections</button>
            </div>
          </div>

        </div>
      </div>
    </div>
    </ng-template>
  </li>
  <li [ngbNavItem]="2" class="nav-item">
    <a ngbNavLink class="nav-link">Inactive</a>
    <ng-template ngbNavContent>
    <div class="row tab-pane">
      <div *ngFor="let device of disabledDeviceList" class="col-12 col-md-6 col-lg-12 col-xl-6">
        <div class="grid device-card" [class.offline]="!device.online" [class.connected]="device.connection_status === 'connected'" [class.border-success]="device.selected">
          <div class="grid-body text-gray row">
            <div class="device-header">
              <div class="">
                <p class="display-6 device-title" routerLink="{{device.id}}">
                  <span class="device-title-text">{{device.name}}</span>
                  <img *ngIf="device.online && device.rssi_value" class="signal-icon" src="/assets/images/signal-{{device.rssi_value}}.png" />
                  <span *ngIf="!device.rssi_value || !device.online" class="badge device-status" [class.badge-success]="device.online" [class.badge-danger]="!device.online">&nbsp;</span>
                  <!--button type="button" class="btn btn-trasnparent action-btn btn-xs component-flat pr-0 expand-button"  routerLink="{{device.id}}">
                    <i class="mdi mdi-arrow-expand"></i>
                  </button-->
                  <!--span *ngIf="device?.cell_state?.toLowerCase()?.includes('pause')" class="badge cell-state">Paused</span-->
                </p>
                <input type="checkbox" class="form-check-input device-checkbox" [(ngModel)]="device.selected" (ngModelChange)="updateSelectedDevices()" />
              </div>
            </div>
          </div>

          <div class="grid-body text-gray row device-info">
            <div class="col-6 col-xl-3 col-lg-3 col-md-6 col-sm-3">
              <span class="info-label">MAC/Serial</span>
              {{device.code}}
            </div>
            <div class="col-6 col-xl-3 col-lg-3 col-md-6 col-sm-3">
              <span class="info-label">Org</span>
              {{device.org?.name}}
            </div>
            <div class="col-6 col-xl-3 col-lg-3 col-md-6 col-sm-3">
              <span class="info-label">Site</span>
              {{device.location?.company}}
            </div>
            <div class="col-6 col-xl-3 col-lg-3 col-md-6 col-sm-3">
              <!--
              <span class="info-label">Cell Plan</span>
              <span>{{device.cell_usage ? (device.cell_usage / 1000000) + 'Mb' : '?'}} / </span>
              <span *ngIf="device.cell_limit === -1">Unlimited</span>
              <span *ngIf="device.cell_limit !== -1">{{device.cell_limit ? (device.cell_limit / 1000000) + 'Mb' : '?'}}</span>
              -->
              <button type="button" class="btn btn-primary btn-xs connect-button" *ngIf="device.connection_status === 'disconnected'" (click)="activateDevice(device)">
                <i class="mdi mdi-lan-connect"></i> Connect
              </button>

              <button type="button" class="btn btn-success btn-xs connect-button" *ngIf="device.connection_status === 'connected'" (click)="deactivateDevice(device)">
                <i *ngIf="device.connections.length <= 2" class="mdi mdi-lan-connect"></i> Connected
              </button>

              <button type="button" class="btn btn-primary btn-xs connect-button" *ngIf="device.connection_status === 'connecting'" disabled="disabled">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span class="sr-only">Loading...</span>
              </button>
            </div>
          </div>

          <div class="grid-body text-gray row">
            <div *ngFor="let connection of device.connections.slice(0,3);">
            <div *ngIf="connection.ips.length" class="col-3 device-connection">
              <span class="device-type">{{connection.vendor.name}}</span>
              <div *ngIf="connection.ips.length > 1" class="dropdown">
                <button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{connection.ips.length+' IPs'}}
                </button>
                <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                  <li *ngFor="let ip of connection.ips" class="dropdown-item">{{ip.ip}}</li>
                </ul>
              </div>
              <span *ngIf="connection.ips.length <= 1">
                {{connection.ips.length !== 1 ? connection.ips.length+' IPs' : connection.ips[0]?.ip}}
              </span>
            </div>
            </div>
            <div *ngIf="device.connection_status === 'connected'" class="col-3 device-connection">
              <button type="button" class="btn btn-primary btn-xs" routerLink="{{device.id}}">All Connections</button>
            </div>
          </div>

        </div>
      </div>
    </div>
    </ng-template>
  </li>
  <li class="search-box">
    <!--input type="text" id="device_search" class="form-control" placeholder="Search..." [ngModel]="searchFilter" (ngModelChange)="updateFilter($event)" /-->
    <app-select [collection]="formattedDevicesObservable" [filters]="allowedFilters" (actOnSelection)="filterDevices($event)"></app-select>
  </li>
</ul>

<div [ngbNavOutlet]="nav"></div>

<ng-template #bulkEditContent let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Profile update</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
		<div class="selected-devices">
      {{selectedDevices.length}} Devices Selected:
      <ul>
        <li *ngFor="let device of selectedDevices">{{device.name}}</li>
      </ul>
		</div>
    <hr />
    <form>
      <div class="form-group">
        <label for="bulkAction">Select an action...</label>
        <div class="input-group">
          <select id="bulkAction" class="form-control" name="bulkAction" [(ngModel)]="bulkAction" placeholder="Select an action...">
            <option value="activate">Activate</option>
            <option value="deactivate">Deactivate</option>
            <option value="pause_cell">Pause Cellular</option>
            <option value="unpause_cell">Unpause Cellular</option>
            <option value="edit">Edit Details</option>
            <option value="delete">Delete</option>
          </select>
        </div>
      </div>
      <div *ngIf="bulkAction === 'edit'">
        <app-bulk-device-edit [deviceIds]="selectedDeviceIds"></app-bulk-device-edit>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="modal.close('save')" *ngIf="bulkAction !== null && bulkAction !== 'edit'">Save</button>
  </div>
</ng-template>
